<template>
  <footer class="h-(--ui-header-height) z-10 w-full py-1 bg-white text-center dark:bg-[#162031] ui-ring rounded-none flex items-center justify-center">
    <div v-text="`👉 © 2025 GemyClass — التعليم بقى أسهل`" class="text-lg md:text-lg font-bold"/>
  </footer>
</template>

